import * as allTypes from '../mutation-type';
import * as types from './user-mutation-type';
import { getUser, login, refresh } from '../../api/login/index';
import { resetState } from '../store';

function initialState() {
  return {
    security: { isLogged: false },
    site: '',
    afficherAzimut: true,
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.LOG_IN](state, user) {
    state.security = { isLogged: true, ...user };
  },
  [types.SET_USER](state, user) {
    state.user = user;
  },
  [types.LOG_OUT](state) {
    state.security = { isLogged: false };
    state.user = {};
    resetState();
  },
  [types.SET_SITE](state, site) {
    state.site = site;
  },
  [types.SET_AZIMUT](state, afficherAzimut) {
    state.afficherAzimut = afficherAzimut;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  logIn: ({ getters, commit }, payload) => {
    return new Promise((resolve, reject) => {
      login(payload.site, payload.email, payload.password).then((response) => {
        if (payload.site !== getters.site || payload.email !== getters.userEmail) {
          resetState();
          commit(types.SET_SITE, payload.site);
        }
        commit(types.LOG_IN, response.data);
        getUser(payload.email).then((response) => {
          commit(types.SET_USER, response.data);
          resolve();
        }).catch(err => {
          commit(types.LOG_OUT);
          reject(err.code);
        });
      }).catch(err => reject(err.code));
    });
  },
  refresh: ({ commit }) => {
    return new Promise((resolve, reject) => {
      refresh().then((response) => {
        commit(types.LOG_IN, response.data);
        resolve();
      }).catch(err => {
        commit(types.LOG_OUT);
        reject(err.code);
      });
    });
  },
  logOut: ({ commit }) => {
    return new Promise((resolve) => {
      commit(types.LOG_OUT);
      resolve();
    });
  },
  setAzimut: (commit, state, newValue) => {
    commit('SET_AZIMUT', newValue);
    return state.afficherAzimut;
  },
};

const getters = {
  accessToken: state => {
    return state.security.access_token;
  },
  refreshToken: state => {
    return state.security.refresh_token;
  },
  isLogged: state => {
    return state.security.isLogged;
  },
  hasGeoMarketing: state => {
    return state.user.accesGeoMarketing;
  },
  userEmail: state => {
    return state.user.email;
  },
  site: state => {
    return state.site;
  },
  afficherAzimut: state => {
    return state.afficherAzimut;
  },
  isSupport: state => {
    return state.user.email === 'support@quadra-diffusion.fr';
  },
};


export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js